export default [
  {
    path:'/admin/distributor/basic_settings',
    name: 'BasicSettings',
    component: () => import('@/views/distributor/basic_settings'),
    meta:{
      title:'基础设置',
      keepAlive:false
    }
  },
  {
    path:'/admin/distributor/list',
    name: 'DistributorList',
    component: () => import('@/views/distributor/list'),
    meta:{
      title:'分销商',
      keepAlive:false
    }
  },
  {
    path:'/admin/distributor/withdraw',
    name: 'Wthdraw',
    component: () => import('@/views/distributor/withdraw'),
    meta:{
      title:'提现管理',
      keepAlive:false
    }
  },
  {
    path:'/admin/distributor/order/list',
    name: 'distrbutorOrder',
    component: () => import('@/views/distributor/order_list'),
    meta:{
      title:'分销订单',
      keepAlive:false
    }
  },
  {
    path:'/admin/distributor/grade',
    name: 'DistributorGrade',
    component: () => import('@/views/distributor/grade'),
    meta:{
      title:'分销商等级',
      keepAlive:false
    }
  },
  {
    path:'/admin/distributor/rule',
    name: 'DistributorRule',
    component: () => import('@/views/distributor/rule'),
    meta:{
      title:'等级规则',
      keepAlive:false
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/distributor.js